import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './index.scss';
import { logout } from '../../store/actions/login';
import Tooltip from '@material-ui/core/Tooltip';
import SairIcon from '../../image/sair.svg';
import HomeIcon from '../../image/home.svg';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleSubmitExit = this.handleSubmitExit.bind(this);
  }

  handleSubmitExit = () => {
    const { logout = [] } = this.props;
    logout();
  };

  render() {
    const { primeiroNome, codigo, name } = this.props;
    const path = window.location.pathname;

    return (
      <>
        {path === '/home' ? (
          <>
            <div className={`Header ${this.props.class}`}>
              <p className="name">{`Olá, ${primeiroNome}!`}</p>
              <Tooltip title="Sair">
                <Link to="/login" className="sair" onClick={() => this.handleSubmitExit()}>
                  <img src={SairIcon} alt="Sair" />
                </Link>
              </Tooltip>
            </div>
            <p className="cod-prestador">{`Cód. do prestador ${codigo}`}</p>
          </>
        ) : (
          <div className="header-navigation noselect">
              <Link to="/home">
                <img src={HomeIcon} alt="Home" />
              </Link>
              <span>{name}</span>
            </div>
          )}
      </>
    );
  }
}

Header.defaultProps = {
  class: '',
  primeiroNome: null,
  codigo: null
};

Header.propTypes = {
  class: PropTypes.string,
  primeiroNome: PropTypes.string,
  codigo: PropTypes.number,
  logout: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

function splitFirstAndLastName(name = '') {
  const splitedName = name.split(' ');
  const first = splitedName[0] || '';
  const last = splitedName[splitedName.length - 1] || '';

  return [first, last];
}

function capitalize(value = '') {
  const firstLetter = value
    .toLowerCase()
    .charAt(0)
    .toUpperCase();

  const remainingLetters = value.substring(1, value.length).toLowerCase();

  return `${firstLetter}${remainingLetters}`;
}

const mapStateToProps = ({ login }) => {
  const [primeiroNome, ultimoNome] = splitFirstAndLastName(login.user.nomeUsuario);

  return {
    login,
    primeiroNome: capitalize(primeiroNome),
    ultimoNome: capitalize(ultimoNome),
    codigo: login.user.codigo
  };
};

export default connect(mapStateToProps, { logout })(Header);